import { AppBar, Button, Dialog, Grid, IconButton, Paper, Slide, Toolbar } from "@mui/material";
import { Close } from "@mui/icons-material";
import { IProduct } from "./Products";
import React from "react";
import { TransitionProps } from "@mui/material/transitions";
import "./DetailView.css";
import { microEventBus } from "../App";

export interface IDetailsProps {
    open: boolean;
    product: IProduct | null;
    handleClose(): void;
    username: string;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {children: React.ReactElement},
    ref: React.Ref<unknown>,
){
    return <Slide direction="left" ref={ref} {...props} />
});

export class DetailView extends React.Component<IDetailsProps>{
    constructor(props: IDetailsProps){
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    render() {
        return (
            <div className="full-screen-details-dialogue">
                <Dialog fullScreen open={this.props.open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="close"
                                onClick={this.handleClose}
                            >
                                <Close/>
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <div className="details-paper-padding-top">
                        <Paper className="details-paper-body">
                            <Grid container spacing={3} alignItems="flex-start">
                                <Grid size={5}>
                                    <img className="large-imgage" src={this.props.product?.image} alt="lol image" />
                                </Grid>

                                <Grid size={7} container direction="column" justifyContent="flex-start" alignItems="stretch">
                                    <Grid><h1>{this.props.product?.name}</h1></Grid>
                                    <Grid><h2>{this.props.product?.type}</h2></Grid>
                                    <Grid><p>{this.props.product?.longDescription}</p></Grid>
                                </Grid>
                            </Grid>

                            <Grid>&nbsp;</Grid>

                            <form noValidate autoComplete="off" onSubmit={this.onSubmit}>
                                <Grid>
                                    <Button type="submit" variant="contained" color="primary">
                                        Add to Selection
                                    </Button>
                                </Grid>
                            </form>
                        </Paper>
                    </div>
                </Dialog>
            </div>
        )
    }

    handleClose() {
        console.log(`Details: handleClose()`)
        this.props.handleClose();
    }

    onSubmit(e: React.FormEvent) {
        e.preventDefault();

        if (this.props.product) {
            microEventBus.broadcast('add-user-cart-item', {
                username: this.props.username,
                productId: this.props.product.id,
                amount: 1,
                name: this.props.product.name,
                type: this.props.product.type,
                image: this.props.product.image,
            });
        }
    }
}
